<template>
  <CustomTooltip :text="exactTime">
    <span> {{ relativeTime }}</span>
  </CustomTooltip>
</template>

<script>
import { DateTime } from 'luxon'
import CustomTooltip from '@/components/custom-tooltip.vue'

export default {
  name: 'RelativeTime',
  components: { CustomTooltip },
  props: {
    time: {
      required: true,
    },
    locale: {
      type: String,
    },
  },
  computed: {
    relativeTime() {
      if (!this.time) {
        return ''
      }

      const datetime = DateTime.fromFilterValue(this.time).toLocal()

      if (this.locale) {
        datetime.setLocale(this.locale)
      }

      return datetime.toRelative()
    },
    exactTime() {
      if (!this.time) {
        return ''
      }

      return DateTime
        .fromFilterValue(this.time)
        .setZone(this.spark.getTimezone())
        .toCustomLocaleString(DateTime.DATETIME_MED_WITH_SECONDS)
    },
  },
}
</script>
